import { LicenseNavCategories } from "../../../pages/Router"
import { Roles } from "../../mp-utils/generic-utils"
import { FeatureFlagName } from "../../mp-utils/generic-utils/feature-flags/types"
import {
  getWorkkeysReplaceTerm,
  getWorkkeysReplaceUrlContentType
} from "../helpers/workkeysReplaceTerms"
import type { NavItem } from "../types"

export const CONFIGURATION_NAV_GROUP = "Configuration"

export const NAV_ITEMS: NavItem[] = [
  {
    // label: "Dashboard",
    // href: "/reporting/dashboard",
    icon: "objects-column",
    isRoot: true,
    children: [
      // {
      //   key: "dev-notes",
      //   label: "Development Notes",
      //   icon: "hand-wave",
      //   href: "/reporting/dev-notes",
      //   subtitle: "Take a quick tour, start boosting scores.",
      //   dismissable: true
      // },
      {
        label: "Teaching Tools",
        icon: "chalkboard-user",
        href: "/reporting/teaching-tools",
        featureFlag: FeatureFlagName.reporting_teaching_tools_module,
        children: [
          {
            label: "Study Plan",
            href: "/reporting/teaching-tools/study-plan",
            navCategory: [LicenseNavCategories.StudyPlan],
            children: [
              {
                label: `Scores By ${getWorkkeysReplaceTerm("student", true)}`,
                hideSideNav: true,
                hideBreadcrumb: true,
                href: "/reporting/teaching-tools/study-plan/scores",
                navCategory: [LicenseNavCategories.StudyPlan]
              }
            ]
          },
          {
            label: "Bell Ringers",
            href: "/reporting/teaching-tools/bell-ringers",
            navCategory: [LicenseNavCategories.elements]
          },
          {
            label: "Books",
            href: "/reporting/teaching-tools/books",
            featureFlag:
              FeatureFlagName.reporting_teaching_tools_e_books_module,
            navCategory: [
              LicenseNavCategories.eBooks,
              LicenseNavCategories.MasteryResources
            ],
            children: [
              {
                label: "Books",
                hideSideNav: true,
                href: "/reporting/teaching-tools/books/mastery-curriculum",
                featureFlag:
                  FeatureFlagName.reporting_teaching_tools_mastery_curriculum_module,
                navCategory: [
                  LicenseNavCategories.eBooks,
                  LicenseNavCategories.MasteryResources
                ]
              },
              {
                label: "",
                hideSideNav: true,
                href: "/reporting/teaching-tools/books/book/:ebookId",
                isEntity: true,
                featureFlag:
                  FeatureFlagName.reporting_teaching_tools_e_books_module,
                navCategory: [
                  LicenseNavCategories.eBooks,
                  LicenseNavCategories.MasteryResources
                ]
              }
            ]
          },
          {
            key: "test-administration",
            label: "Test Administration",
            href: "/reporting/teaching-tools/test-administration",
            featureFlag:
              FeatureFlagName.reporting_teaching_tools_test_administration_module
          },
          {
            label: "Books",
            href: "/reporting/teaching-tools/mastery-curriculum",
            featureFlag:
              FeatureFlagName.reporting_teaching_tools_legacy_mastery_curriculum_module,
            navCategory: [
              LicenseNavCategories.MasteryResources,
              LicenseNavCategories.Resources,
              LicenseNavCategories.ACTResources
            ],
            beta: false
          },
          {
            label: "Skill Review",
            href: "/reporting/teaching-tools/skill-review",
            featureFlag:
              FeatureFlagName.reporting_teaching_tools_skill_review_module,
            navCategory: [LicenseNavCategories.StudyHall],
            beta: false
          },
          {
            label: "Assignments",
            href: "/reporting/teaching-tools/assignments"
          }
          // { label: "Elements", href: "/reporting/teaching-tools/elements" },
        ]
      },
      {
        label: "Usage",
        href: "/reporting/insights/usage",
        icon: "arrow-pointer",
        group: "Insights",
        featureFlag: FeatureFlagName.reporting_insights_usage_module,
        children: [
          {
            label: `${getWorkkeysReplaceTerm("student", true)} Usage`,
            href: "/reporting/insights/usage/learners-usage"
          },
          {
            label: `${getWorkkeysReplaceTerm("teacher", true)} Usage`,
            href: "/reporting/insights/usage/instructors-usage"
          },
          {
            label: "Activity Log",
            href: "/reporting/insights/usage/activity-log",
            featureFlag: FeatureFlagName.reporting_insights_activity_log_module
          }
        ]
      },
      {
        label: "Performance",
        href: "/reporting/insights/performance",
        icon: "chart-line-up",
        group: "Insights",
        featureFlag: FeatureFlagName.reporting_insights_performance_module,
        children: [
          {
            label: "Scores",
            href: "/reporting/insights/performance/scores"
          },
          {
            label: "Questions",
            href: "/reporting/insights/performance/questions",
            featureFlag:
              FeatureFlagName.reporting_insights_performance_questions_module
          },
          {
            label: "Answers",
            href: "/reporting/insights/performance/answers",
            featureFlag:
              FeatureFlagName.reporting_insights_performance_answers_module
          },
          {
            label: "Goals",
            href: "/reporting/insights/performance/goals",
            featureFlag:
              FeatureFlagName.reporting_insights_performance_goals_module
          },
          {
            label: "Content Mastery",
            href: "/reporting/insights/performance/content-mastery",
            featureFlag:
              FeatureFlagName.reporting_insights_performance_content_mastery_module
          }
          // {
          //   label: "Test Mastery",
          //   href: "/reporting/insights/performance/test-mastery"
          // },
          // {
          //   label: "Time Mastery",
          //   href: "/reporting/insights/performance/time-mastery"
          // }
        ]
      },
      {
        label: "Content",
        href: "/reporting/content/content-library",
        featureFlag: FeatureFlagName.reporting_content_module,
        icon: "books",
        group: "Data",
        children: [
          {
            label: "",
            isEntity: true,
            href: "/reporting/content/content-library/:entityType/:entityId"
          }
        ]
        // label: "Content Library",
        // icon: "books",
        // href: "/reporting/content",
        // featureFlag: FeatureFlagName.reporting_content_module,
        // children: [
        //   {
        //
        //   }
        //   // { label: "by Type", href: "/reporting/content/by-type" },
        //   // { label: "by Standard", href: "/reporting/content/by-standard" }
        // ]
      },
      {
        label: "Users and Groups",
        icon: "users",
        group: "Data",
        href: "/reporting/organization",
        featureFlag: FeatureFlagName.reporting_organization_module,
        children: [
          {
            label: "States",
            href: "/reporting/organization/states",
            children: [
              {
                label: "",
                isEntity: true,
                href: "/reporting/organization/states/:entityId"
              }
            ]
          },
          {
            label: "Organizations",
            href: "/reporting/organization/organizations",
            // featureFlag:
            //   FeatureFlagName.reporting_organization_organizations_module,
            children: [
              {
                label: "",
                isEntity: true,
                href: "/reporting/organization/organizations/:entityId"
              }
            ]
          },
          {
            label: "Districts",
            href: "/reporting/organization/districts",
            children: [
              {
                label: "",
                isEntity: true,
                href: "/reporting/organization/districts/:entityId"
              }
            ]
          },
          {
            label: "Admins",
            href: "/reporting/organization/admins",
            children: [
              {
                label: "",
                isEntity: true,
                href: "/reporting/organization/admins/:entityId"
              }
            ]
          },
          {
            label: getWorkkeysReplaceTerm("schools", true),
            href: "/reporting/organization/institutions",
            children: [
              {
                label: "",
                isEntity: true,
                href: "/reporting/organization/institutions/:entityId"
              }
            ]
          },
          {
            label: getWorkkeysReplaceTerm("teachers", true),
            href: "/reporting/organization/instructors",
            children: [
              {
                label: "",
                isEntity: true,
                href: "/reporting/organization/instructors/:entityId"
              }
            ]
          },
          {
            label: "Classes",
            href: "/reporting/organization/classes",
            children: [
              {
                label: "",
                isEntity: true,
                href: "/reporting/organization/classes/:entityId"
              }
            ]
          },
          {
            label: getWorkkeysReplaceTerm("students", true),
            href: "/reporting/organization/learners",
            children: [
              {
                label: "",
                isEntity: true,
                href: "/reporting/organization/learners/:entityId"
              }
            ]
          },
          {
            label: "License Pools",
            href: "/reporting/organization/license-pools"
          },
          {
            label: "Licenses",
            href: "/reporting/organization/license-assign",
            featureFlag:
              FeatureFlagName.reporting_organization_license_assign_module
          }
        ]
      },
      {
        label: "Profile",
        key: "profile",
        href: "/reporting/profile",
        hideSideNav: true,
        children: []
      },
      {
        label: "Configuration",
        key: "configuration",
        icon: "gears",
        href: "/reporting/configuration",
        group: CONFIGURATION_NAV_GROUP,
        children: [
          {
            label: "Platform Settings",
            href: "/reporting/configuration/platform-settings",
            featureFlag:
              FeatureFlagName.reporting_configuration_platform_settings_module
          },
          {
            label: "Whitelisting",
            href: "/reporting/configuration/whitelisting"
          },
          {
            label: "SAML 2.0",
            href: "/reporting/configuration/saml"
          },
          {
            label: "OneRoster",
            href: "/reporting/configuration/oneroster"
          }
        ]
      }
    ]
  }
]

export const CONFIGURATION_ROLES = [Roles.District_Admin]

export const ROLES_BY_ROUTE: Record<string, string[]> = {
  // Dashboard
  "/reporting/dashboard": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],

  // Saved Views
  "/reporting/saved-views": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],

  // Insights
  "/reporting/insights": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/usage": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/usage/learners-usage": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/usage/instructors-usage": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin
  ],
  "/reporting/insights/usage/activity-log": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/performance": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/performance/content-mastery": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/performance/test-mastery": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/performance/time-mastery": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/performance/questions": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/performance/scores": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/performance/answers": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/insights/performance/goals": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],

  // Content
  "/reporting/content": [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/content/content-library": [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  [`/reporting/content/content-library/${getWorkkeysReplaceUrlContentType(
    "practice-test"
  )}`]: [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  [`/reporting/content/content-library/${getWorkkeysReplaceUrlContentType(
    "mastery-lesson"
  )}`]: [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/content/content-library/mastery-curriculum": [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/content/content-library/element": [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/content/content-library/study-hall": [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/content/content-library/:entityType/:entityId": [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/content/by-type": [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/content/by-standard": [
    // Roles.ACT_Admin,
    // Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],

  // Organization
  "/reporting/organization": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/organization/organizations": [Roles.ACT_Admin],
  "/reporting/organization/organizations/:entityId": [Roles.ACT_Admin],
  "/reporting/organization/states": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin
  ],
  "/reporting/organization/states/:entityId": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin
  ],
  "/reporting/organization/districts": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin
  ],
  "/reporting/organization/districts/:entityId": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin
  ],
  "/reporting/organization/admins": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin
  ],
  "/reporting/organization/admins/:entityId": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin
  ],
  "/reporting/organization/institutions": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin
  ],
  "/reporting/organization/institutions/:entityId": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin
  ],
  "/reporting/organization/instructors": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin
  ],
  "/reporting/organization/instructors/:entityId": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin
  ],
  "/reporting/organization/classes": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/organization/classes/:entityId": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/organization/learners": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/organization/learners/:entityId": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/organization/license-pools": [
    Roles.Super_Administrator,
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin
  ],
  "/reporting/organization/license-assign": [
    Roles.Super_Administrator,
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin
  ],

  // Teaching Tools
  "/reporting/teaching-tools": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/study-plan": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/study-plan/scores": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/study-plan/:subpage": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/study-plan/:subpage/:entityType": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/elements": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/bell-ringers": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/bell-ringers/:entityId": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/mastery-curriculum": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/mastery-curriculum/:program/:subPage/:subcourseId?/:lessonId?":
    [Roles.District_Admin, Roles.School_Admin, Roles.Teacher],
  "/reporting/teaching-tools/mastery-curriculum/:program/test-taking/:courseId/:subcourseId/:lessonId":
    [Roles.District_Admin, Roles.School_Admin, Roles.Teacher],
  "/reporting/teaching-tools/skill-review/:program/:subPage/:subcourseId?/:lessonId?":
    [Roles.District_Admin, Roles.School_Admin, Roles.Teacher],
  "/reporting/teaching-tools/books": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/books/book/:ebookId": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/books/mastery-curriculum": [
    Roles.Super_Administrator,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/test-administration": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/test-administration/new": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/test-administration/:testAdministrationId": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/test-administration/:testAdministrationId/edit": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/skill-review": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/skill-review/:program": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/skill-review/:program/:subPage": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/skill-review/:program/:subPage/:subcourseId": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/assignments": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/assignments/:type(edit|new)/:entityId": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  "/reporting/teaching-tools/assignments/:entityId": [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  // "/reporting/dev-notes": [
  //   Roles.ACT_Admin,
  //   Roles.ACT_Multi_District_Admin,
  //   Roles.District_Admin,
  //   Roles.School_Admin,
  //   Roles.Teacher
  // ],
  "/reporting/profile": [
    Roles.ACT_Admin,
    Roles.ACT_Multi_District_Admin,
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher,
    Roles.Super_Administrator
  ],

  // Configuration
  "/reporting/configuration": CONFIGURATION_ROLES,
  "/reporting/configuration/platform-settings": CONFIGURATION_ROLES,
  "/reporting/configuration/whitelisting": CONFIGURATION_ROLES,
  "/reporting/configuration/saml": CONFIGURATION_ROLES,
  "/reporting/configuration/oneroster": CONFIGURATION_ROLES
}

export const REPORTING_ROUTE_MATCH = [
  "/reporting/:module(teaching-tools)/:submodule(study-plan)/:subpage?/:entityType?",
  "/reporting/:module(teaching-tools)/:submodule(books)/:subpage(book|mastery-curriculum)?/:entityId?",
  "/reporting/:module(insights)/:submodule(performance)/:subpage?/:entityId?",
  "/reporting/:module(insights)/:submodule(usage)/:subpage?",
  "/reporting/:module(content)/:subpage(content-library)/:entityType/:entityId?",
  "/reporting/:module?/:subpage?/:entityId?"
]

// TODO: Remove "performance"-specific route matches when Performance page becomes a separate module.
export const FULL_REPORTING_ROUTE_MATCH = [
  "/reporting/:module(insights)/:subpage(performance)",
  // Skill Review / Mastery Curriculum drill-downs (`/:program/lessons/:topicId`)
  // have more segments than the generic `/:module?/:subpage?/:entityId?` pattern
  // allows, so without this entry the exact match in Reporting.tsx fails and
  // the default custom-view tab falls back to "Default" instead of the page name.
  "/reporting/:module(teaching-tools)/:subpage(skill-review|mastery-curriculum)/:program/:section/:subcourseId?/:lessonId?",
  ...REPORTING_ROUTE_MATCH
]

export const FEATURE_FLAGS_BY_ROUTE: Record<string, FeatureFlagName[]> = {
  // Insights
  "/reporting/insights": [FeatureFlagName.reporting_module],
  get "/reporting/insights/study-plan"() {
    return [
      ...this["/reporting/insights/performance/content-mastery"],
      FeatureFlagName.reporting_insights_performance_content_mastery_module
    ]
  },
  get "/reporting/insights/usage"() {
    return [
      ...this["/reporting/insights"],
      FeatureFlagName.reporting_insights_usage_module
    ]
  },
  get "/reporting/insights/usage/activity-log"() {
    return [
      ...this["/reporting/insights"],
      FeatureFlagName.reporting_insights_usage_module,
      FeatureFlagName.reporting_insights_activity_log_module
    ]
  },
  get "/reporting/insights/usage/learners-usage"() {
    return [
      ...this["/reporting/insights"],
      FeatureFlagName.reporting_insights_usage_module
    ]
  },
  get "/reporting/insights/usage/instructors-usage"() {
    return [
      ...this["/reporting/insights"],
      FeatureFlagName.reporting_insights_usage_module
    ]
  },
  get "/reporting/insights/performance"() {
    return [
      ...this["/reporting/insights"],
      FeatureFlagName.reporting_insights_performance_module
    ]
  },
  get "/reporting/insights/performance/questions"() {
    return [
      ...this["/reporting/insights/performance"],
      FeatureFlagName.reporting_insights_performance_questions_module
    ]
  },
  get "/reporting/insights/performance/scores"() {
    return this["/reporting/insights/performance"]
  },
  get "/reporting/insights/performance/answers"() {
    return [
      ...this["/reporting/insights/performance"],
      FeatureFlagName.reporting_insights_performance_answers_module
    ]
  },
  get "/reporting/insights/performance/goals"() {
    return [
      ...this["/reporting/insights/performance"],
      FeatureFlagName.reporting_insights_performance_goals_module
    ]
  },
  get "/reporting/insights/performance/content-mastery"() {
    return [
      ...this["/reporting/insights/performance"],
      FeatureFlagName.reporting_insights_performance_content_mastery_module
    ]
  },

  // Content
  "/reporting/content": [
    FeatureFlagName.reporting_module,
    FeatureFlagName.reporting_content_module
  ],
  get "/reporting/content/content-library"() {
    return [...this["/reporting/content"]]
  },
  get "/reporting/content/content-library/:entityType/:entityId"() {
    return this["/reporting/content/content-library"]
  },

  // Organization
  "/reporting/organization": [
    FeatureFlagName.reporting_module,
    FeatureFlagName.reporting_organization_module
  ],
  get "/reporting/organization/organizations"() {
    return [...this["/reporting/organization"]]
  },
  get "/reporting/organization/organizations/:entityId"() {
    return this["/reporting/organization/organizations"]
  },
  get "/reporting/organization/states"() {
    return this["/reporting/organization"]
  },
  get "/reporting/organization/states/:entityId"() {
    return this["/reporting/organization/states"]
  },
  get "/reporting/organization/districts"() {
    return this["/reporting/organization"]
  },
  get "/reporting/organization/districts/:entityId"() {
    return this["/reporting/organization/districts"]
  },
  get "/reporting/organization/admins"() {
    return this["/reporting/organization"]
  },
  get "/reporting/organization/admins/:entityId"() {
    return this["/reporting/organization/admins"]
  },
  get "/reporting/organization/institutions"() {
    return this["/reporting/organization"]
  },
  get "/reporting/organization/institutions/:entityId"() {
    return this["/reporting/organization/institutions"]
  },
  get "/reporting/organization/instructors"() {
    return this["/reporting/organization"]
  },
  get "/reporting/organization/instructors/:entityId"() {
    return this["/reporting/organization/instructors"]
  },
  get "/reporting/organization/classes"() {
    return this["/reporting/organization"]
  },
  get "/reporting/organization/classes/:entityId"() {
    return this["/reporting/organization/classes"]
  },
  get "/reporting/organization/learners"() {
    return this["/reporting/organization"]
  },
  get "/reporting/organization/learners/:entityId"() {
    return this["/reporting/organization/learners"]
  },
  get "/reporting/organization/license-pools"() {
    return this["/reporting/organization"]
  },
  get "/reporting/organization/license-assign"() {
    return [
      ...this["/reporting/organization"],
      FeatureFlagName.reporting_organization_license_assign_module
    ]
  },

  // Teaching Tools
  "/reporting/teaching-tools": [
    FeatureFlagName.reporting_module,
    FeatureFlagName.reporting_teaching_tools_module
  ],
  get "/reporting/teaching-tools/bell-ringers"() {
    return this["/reporting/teaching-tools"]
  },
  get "/reporting/teaching-tools/bell-ringers/:entityId"() {
    return this["/reporting/teaching-tools/bell-ringers"]
  },
  get "/reporting/teaching-tools/books/mastery-curriculum"() {
    return [
      ...this["/reporting/teaching-tools"],
      ...this["/reporting/teaching-tools/books"],
      FeatureFlagName.reporting_teaching_tools_mastery_curriculum_module
    ]
  },
  get "/reporting/teaching-tools/books"() {
    return [
      ...this["/reporting/teaching-tools"],
      FeatureFlagName.reporting_teaching_tools_e_books_module
    ]
  },
  get "/reporting/teaching-tools/books/book/:ebookId"() {
    return [
      ...this["/reporting/teaching-tools"],
      ...this["/reporting/teaching-tools/books"]
    ]
  },
  get "/reporting/teaching-tools/test-administration"() {
    return [
      ...this["/reporting/teaching-tools"],
      FeatureFlagName.reporting_teaching_tools_test_administration_module
    ]
  },
  get "/reporting/teaching-tools/test-administration/new"() {
    return this["/reporting/teaching-tools/test-administration"]
  },
  get "/reporting/teaching-tools/test-administration/:testAdministrationId"() {
    return this["/reporting/teaching-tools/test-administration"]
  },
  get "/reporting/teaching-tools/test-administration/:testAdministrationId/edit"() {
    return this["/reporting/teaching-tools/test-administration"]
  },
  get "/reporting/teaching-tools/skill-review"() {
    return [
      ...this["/reporting/teaching-tools"],
      FeatureFlagName.reporting_teaching_tools_skill_review_module
    ]
  },
  get "/reporting/teaching-tools/assignments"() {
    return this["/reporting/teaching-tools"]
  },
  get "/reporting/teaching-tools/assignments/edit/:entityId"() {
    return this["/reporting/teaching-tools/assignments"]
  },
  get "/reporting/teaching-tools/assignments/:entityId"() {
    return this["/reporting/teaching-tools/assignments"]
  }
}

export const ROUTES_WITH_DISTRICT_SELECTION_CHECK: string[] = [
  "/reporting/organization",
  "/reporting/organization/states",
  "/reporting/organization/districts",
  "/reporting/organization/admins",
  "/reporting/organization/institutions",
  "/reporting/organization/instructors",
  "/reporting/organization/classes",
  "/reporting/organization/learners",
  "/reporting/organization/license-pools",
  "/reporting/organization/license-assign",
  "/reporting/insights/usage/learners-usage",
  "/reporting/insights/usage/instructors-usage",
  "/reporting/insights/usage/activity-log",
  "/reporting/insights/performance/scores",
  "/reporting/insights/performance/questions",
  "/reporting/insights/performance/answers",
  "/reporting/insights/performance/goals",
  "/reporting/insights/performance/content-mastery",
  "/reporting/teaching-tools/test-administration",
  "/reporting/teaching-tools/test-administration/:entityId",
  "/reporting/teaching-tools/assignments"
]
